<template>
    <div v-loading="loading" class="zrd-result">
        <el-divider></el-divider>
        <el-row type="flex" align="middle">
            <span>选择设备：</span>
            <el-select v-model="selectedSerialNumber" clearable filterable placeholder="请选择设备" @change="handleDeviceChange">
                <el-option v-for="device in devices" :key="device.serialNumber" :label="device.remark ? device.serialNumber + '(' + device.remark + ')' : device.serialNumber" :value="device.serialNumber">
                </el-option>
            </el-select>
            <el-button type="info" icon="vxe-icon-refresh" style="margin-left: 20px;" @click="getList">刷新</el-button>
        </el-row>

        <vxe-table ref="resultTable" :data="pagedTableData" border show-overflow :loading="loading" :row-config="{ isHover: true }" style="margin-top: 10px;">
            <vxe-column field="serialNumber" title="序列号" min-width="130"></vxe-column>
            <vxe-column field="shiYanShiJian" title="试验时间" min-width="170" :formatter="formatDate"></vxe-column>
            <vxe-column field="shiYanBianHao" title="试验编号" min-width="130"></vxe-column>
            <vxe-column field="zhenRuDu1" title="针入度1(mm)" min-width="100" align="right"></vxe-column>
            <vxe-column field="zhenRuDu2" title="针入度2(mm)" min-width="100" align="right"></vxe-column>
            <vxe-column field="zhenRuDu3" title="针入度3(mm)" min-width="100" align="right"></vxe-column>
            <vxe-column field="pingJunZhi" title="平均值" min-width="100" align="right" :formatter="formatAverage"></vxe-column>
            <vxe-column field="version" title="版本" min-width="100"></vxe-column>
            <vxe-column field="createTime" title="创建时间" min-width="170" :formatter="formatDate"></vxe-column>
            <vxe-column title="操作" width="80" fixed="right">
                <template #default="{ row }">
                    <vxe-button mode="text" status="primary" icon="vxe-icon-edit" circle @click="editRow(row)"></vxe-button>
                </template>
            </vxe-column>
        </vxe-table>
        <vxe-pager align="left" :current-page.sync="page.currentPage" :page-size.sync="page.pageSize" :total="page.total" :layouts="['PrevPage', 'Jump', 'PageCount', 'NextPage', 'Total']" @page-change="handlePageChange">
        </vxe-pager>
        <el-empty v-if="!selectedSerialNumber" description="请选择设备"></el-empty>

        <el-dialog title="编辑针入度结果" :visible.sync="editDialogVisible" width="520px">
            <el-form ref="editForm" :model="editForm" :rules="editFormRules" label-width="100px">
                <el-form-item label="序列号">
                    <el-input v-model="editForm.serialNumber" disabled></el-input>
                </el-form-item>
                <el-form-item label="试验编号" prop="shiYanBianHao">
                    <el-input v-model="editForm.shiYanBianHao"></el-input>
                </el-form-item>
                <el-form-item label="试验时间" prop="shiYanShiJian">
                    <el-date-picker v-model="editForm.shiYanShiJian" type="datetime" value-format="yyyy-MM-ddTHH:mm:ss.SSS[Z]" style="width: 100%;"></el-date-picker>
                </el-form-item>
                <el-form-item label="针入度1(mm)" prop="zhenRuDu1">
                    <el-input-number v-model="editForm.zhenRuDu1" :controls="false" :precision="2" style="width: 100%;"></el-input-number>
                </el-form-item>
                <el-form-item label="针入度2(mm)" prop="zhenRuDu2">
                    <el-input-number v-model="editForm.zhenRuDu2" :controls="false" :precision="2" style="width: 100%;"></el-input-number>
                </el-form-item>
                <el-form-item label="针入度3(mm)" prop="zhenRuDu3">
                    <el-input-number v-model="editForm.zhenRuDu3" :controls="false" :precision="2" style="width: 100%;"></el-input-number>
                </el-form-item>
            </el-form>
            <span slot="footer">
                <el-button @click="editDialogVisible = false">取消</el-button>
                <el-button type="primary" :loading="saveLoading" @click="saveEdit">保存</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import moment from "moment";

export default {
    data() {
        return {
            loading: false,
            devices: [],
            selectedSerialNumber: "",
            tableData: [],
            editDialogVisible: false,
            saveLoading: false,
            editForm: {},
            editFormRules: {
                shiYanBianHao: [{ required: true, message: "请输入试验编号", trigger: "blur" }],
                shiYanShiJian: [{ required: true, message: "请选择试验时间", trigger: "change" }],
                zhenRuDu1: [{ required: true, message: "请输入针入度1", trigger: "change" }],
                zhenRuDu2: [{ required: true, message: "请输入针入度2", trigger: "change" }],
                zhenRuDu3: [{ required: true, message: "请输入针入度3", trigger: "change" }],
            },
            page: {
                currentPage: 1,
                pageSize: 10,
                total: 0,
            },
        };
    },
    computed: {
        pagedTableData() {
            const start = (this.page.currentPage - 1) * this.page.pageSize;
            return this.tableData.slice(start, start + this.page.pageSize);
        },
    },
    methods: {
        loadDevices() {
            this.axios.post("WXCW81/GetMyCompanyDevice2", {
                deviceType: "ZRD200",
            }).then((response) => {
                this.devices = response.data.data || [];
                if (this.devices.length > 0) {
                    this.selectedSerialNumber = this.devices[0].serialNumber;
                    this.getList();
                }
            });
        },
        handleDeviceChange() {
            this.page.currentPage = 1;
            this.getList();
        },
        getList() {
            if (!this.selectedSerialNumber) {
                this.tableData = [];
                this.page.total = 0;
                return;
            }
            this.loading = true;
            this.axios.post("ZRD_Result/GetList", {
                serialNumber: this.selectedSerialNumber,
            }).then((response) => {
                const result = response.data.data || {};
                this.tableData = result.data || [];
                this.page.total = result.total || this.tableData.length;
                if (this.page.currentPage > 1 && this.pagedTableData.length === 0) {
                    this.page.currentPage = 1;
                }
            }).finally(() => {
                this.loading = false;
            });
        },
        handlePageChange({ currentPage, pageSize }) {
            this.page.currentPage = currentPage;
            this.page.pageSize = pageSize;
        },
        editRow(row) {
            this.editForm = { ...row };
            this.editDialogVisible = true;
            this.$nextTick(() => {
                this.$refs.editForm.clearValidate();
            });
        },
        saveEdit() {
            this.$refs.editForm.validate((valid) => {
                if (!valid) {
                    return;
                }
                this.editForm.pingJunZhi = this.calculateAverage(this.editForm);
                this.saveLoading = true;
                this.axios.post("ZRD_Result/UpdateModel", this.editForm).then((response) => {
                    if (response.data.code !== 0 && response.data.code !== 101) {
                        this.$message.error(response.data.msg || "保存失败");
                        return;
                    }
                    this.$message.success("保存成功");
                    this.editDialogVisible = false;
                    this.getList();
                }).finally(() => {
                    this.saveLoading = false;
                });
            });
        },
        formatDate({ cellValue }) {
            return cellValue ? moment(cellValue).format("YYYY-MM-DD HH:mm:ss") : "";
        },
        calculateAverage(row) {
            const values = [row.zhenRuDu1, row.zhenRuDu2, row.zhenRuDu3].map(Number);
            if (values.some((value) => Number.isNaN(value))) {
                return "";
            }
            return Number((values.reduce((sum, value) => sum + value, 0) / values.length).toFixed(2));
        },
        formatAverage({ row }) {
            return this.calculateAverage(row);
        },
    },
    mounted() {
        this.loadDevices();
    },

};
</script>

<style scoped>
.zrd-result {
    padding: 0 10px;
}
</style>